import React from 'react'
import { DateRangePicker } from 'rsuite';

export default function DateRangePickerPrimary(props) {

	const { defaultValue, disabledDate, placement, paddingLeft } = props;

	const { dateRange, dateRangeChange } = props;
	const [startDate, endDate] = dateRange;
	const style = { border: 'none', boxShadow: 'none' };

	// safely parse start/end into Date objects only if present and valid
	const toDate = (v) => {
		if (!v) return null;
		const d = new Date(v);
		return isNaN(d.getTime()) ? null : d;
	}
	const parsedStart = toDate(startDate);
	const parsedEnd = toDate(endDate);
	// prefer provided defaultValue (if any), otherwise use parsedStart/parsedEnd only when both valid
	const pickerDefault = defaultValue ? defaultValue : (parsedStart && parsedEnd ? [parsedStart, parsedEnd] : undefined);

	return (
		<DateRangePicker
			size="lg"
			appearance="subtle"
			placeholder="Select start and end date (DD/MM/YYYY)"
			className="form-control hide-border-control"
			character=" - "
			format='dd/MM/yyyy'
			style={style}
			placement={placement}
			defaultValue={pickerDefault}
			disabledDate={disabledDate}
			startdate={startDate}
			enddate={endDate}
			onChange={(update) => {
				dateRangeChange(update);
			}}
			cleanable={false}
		/>
	)
}

